// extracted by mini-css-extract-plugin
export default {"numberCol":"confirmation__numberCol___in8tg","descStepCol":"confirmation__descStepCol___F3EGo","hyperlink":"confirmation__hyperlink___ZEHap"};